/**
 * Navigation utilities for the AI Dashboard Assistant.
 */

import type { DashboardUrl } from './definitions';
import { createPath } from 'history';

/**
 * Build a URL string from a DashboardUrl (pathname + search + hash)
 */
export function buildUrl(ref: DashboardUrl): string {
    return createPath(ref);
}
